import React from "react";
import { Alert as BsAlert } from "react-bootstrap";

const typeToVariantMapping: Record<string, string> = {
  error: "danger",
};

interface AlertProps {
  type: "warning" | "success" | "error";
  msg: string;
  dismissible?: boolean;
  onClose?: () => void;
}

const Alert = ({ type, msg, dismissible = false, onClose }: AlertProps) => {
  return (
    <BsAlert
      dismissible={dismissible}
      onClose={onClose}
      variant={typeToVariantMapping[type] || type}
    >
      {msg}
    </BsAlert>
  );
};

export default Alert;
